import { Field } from "formik";
import { registerWidget } from "./registry";
import { getClassName } from "./utils";

export const fileFormField = (config: any, formikParams: any) => {
  const extraProps = config ?? {};
  if (formikParams.handleChange != null)
    extraProps["onChange"] = formikParams.handleChange;
  return (
    <Field
      {...extraProps}
      key={config.key ?? config.name}
      name={config.name}
      type={config.type}
      className={getClassName(config)}
      id={config.name}
    />
  );
};

registerWidget("file", fileFormField);
